import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '@environments/environment';
import { NgxsModule } from '@ngxs/store';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';
import { UiStoreModule } from './ui-store/ui-store.module';
import { AuthStoreModule } from './auth-store/auth-store.module';
import { DataSourceConfigsStoreModule } from './data-source-configs-store/data-source-configs-store.module';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { FormsStoreModule } from './forms-store/forms-store.module';
import { RegisterStoreModule } from './register-account/register-store.module';
import { ProductStoreModule } from './product-store/product-store.module';
import { BreadcrumbStoreModule } from './breadcrumb-store/breadcrumb-store.module';
import { WishListStoreModule } from './wish-list-store/wish-list-store.module';
import { CartStoreModule } from './cart/cart-store.module';
import { OrderStoreModule } from './order-store/order-store.module';
import { AuthState } from './auth-store/auth.state';
import { ContactStoreModule } from './contact-store/contact-store.module';
import { SearchStoreModule } from './search-store/search-store.module';

@NgModule({
  imports: [
    CommonModule,
    NgxsModule.forRoot([], { developmentMode: environment.enableNgxsDevMode }),
    NgxsRouterPluginModule.forRoot(),
    NgxsFormPluginModule.forRoot(),
    NgxsReduxDevtoolsPluginModule.forRoot({ disabled: !environment.enableNgxsDevMode, name: 'ngxsTemplate NGXS DevTools' }),
    NgxsLoggerPluginModule.forRoot({ disabled: !environment.enableNgxsDevMode }),
    NgxsStoragePluginModule.forRoot({
      key: [
        AuthState,
        'ui.theme',
        'wishList.wishList.items',
        'cart.cartItems'
      ]
    }),
    UiStoreModule,
    AuthStoreModule,
    DataSourceConfigsStoreModule,
    FormsStoreModule,
    OrderStoreModule,
    FormsStoreModule,
    RegisterStoreModule,
    ProductStoreModule,
    BreadcrumbStoreModule,
    WishListStoreModule,
    CartStoreModule,
    ContactStoreModule,
    OrderStoreModule,
    SearchStoreModule
  ],
  declarations: []
})
export class NgxsStoreModule {}
